<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

// Refs.
const videoElement = ref(null);
const containerRef = ref(null);
let observer = null;

// Methods.
const handleIntersection = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting && videoElement.value) {
      // Video entered viewport, start playing.
      videoElement.value.play().catch((error) => {
        // Handle autoplay restrictions (e.g., browser policies).
        console.warn('Video autoplay failed:', error);
      });
    }
  });
};

// Lifecycle.
onMounted(() => {
  // Find the video element within this component instance.
  const video = containerRef.value?.querySelector('video');

  if (video) {
    videoElement.value = video;

    // Ensure video has required attributes.
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('loop', '');
    video.removeAttribute('controls');

    // Set up Intersection Observer.
    observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1, // Trigger when 10% of video is visible.
    });

    observer.observe(video);
  }
});

onUnmounted(() => {
  // Clean up observer.
  if (observer && videoElement.value) {
    observer.unobserve(videoElement.value);
    observer.disconnect();
  }
});
</script>

<template>
  <div class="video-short" ref="containerRef">
    <slot></slot>
  </div>
</template>
